import { FAB_SURGE_GET_USER_LIST, FAB_SURGE_GET_USER_LIST_SUCCESS, FAB_SURGE_GET_USER_LIST_ERROR, FAB_SURGE_GET_USER_LIST_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetFabUserList = (state = initialState, action) => {
  switch (action.type) {
    case FAB_SURGE_GET_USER_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case FAB_SURGE_GET_USER_LIST_SUCCESS:
      console.log('hello action', action.payload);
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case FAB_SURGE_GET_USER_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case FAB_SURGE_GET_USER_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetFabUserList;
